import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const SITE_URL = "https://velocityelectricalsurplus.com";

const setMeta = (attr, key, value) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
};

const setCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

export default function Seo({ title, description }) {
  const { pathname } = useLocation();
  useEffect(() => {
    const url = `${SITE_URL}${pathname}`;
    setCanonical(url);
    setMeta("property", "og:url", url);
    if (title) {
      document.title = title;
      setMeta("property", "og:title", title);
      setMeta("name", "twitter:title", title);
    }
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
      setMeta("name", "twitter:description", description);
    }
  }, [title, description, pathname]);
  return null;
}
